// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"sv_a bhs_b bhs_bj","HomeBaseBanner__hint":"sv_b bhs_vh","HomeBaseBanner__link":"sv_c"};